export let ShimTag = /*#__PURE__*/function (ShimTag) {
  ShimTag["DIV"] = "div";
  ShimTag["SPAN"] = "span";
  return ShimTag;
}({});